export const handleRegistrationStatus = (payload) => {
  const isRegCompleted = payload?.data?.is_registration_completed;

  if (typeof isRegCompleted !== "undefined") {
    localStorage.setItem("is_reg_completed", JSON.stringify(isRegCompleted));
  }
};
